import React from 'react';
import PropTypes from 'prop-types';

import Env from '../../../../util/env';
import {projectStatusEnum, serviceURL} from '../../../../util/uiconstants';

import ProjectList from '../../../Common/ProjectList';

const ActiveProjects = ({...rest}) => {
	const url = `${Env.getBaseURL(serviceURL)}projects?expand=clients,users&filter=default`;

	const filterCondition = ({status}) => status !== projectStatusEnum.COMPLETED;

	const props = {...rest, url, filterCondition};

	return <ProjectList {...props} />;
};

ActiveProjects.propTypes = {};

ActiveProjects.defaultProps = {};

export default ActiveProjects;
